import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=fc2bc992"
import script from "./WordCloud.vue?vue&type=script&lang=js"
export * from "./WordCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports